const SDK_VERSION = '7.16.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
